class DeliverySaverPlanFrequenciesController {
    $onInit() {
        this.selectedPlan = this.plans && this.plans[0];
    }

    changePlanSelection() {
        if (this.onChangePlanSelection) {
            this.onChangePlanSelection({ selectedPlan: this.selectedPlan });
        }
    }
}

const DeliverySaverPlanFrequenciesComponentDefinition = {
    controller: DeliverySaverPlanFrequenciesController,
    template: require('./delivery-saver-plan-frequencies.component.html').trim(),
    bindings: {
        onChangePlanSelection: '&',
        plans: '<',
    },
};

module.exports = {
    DeliverySaverPlanFrequenciesComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/deliverysaver/planfrequencies/delivery-saver-plan-frequencies.component.js